import styled from 'styled-components/macro'

import { Link } from 'react-router-dom'

export const CategoryPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`
export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
  h2 {
    margin: 5px 0 0;
  }
`
export const Title = styled(Link)`
  font-size: 34px;
  letter-spacing: 1.2rem;
  cursor: pointer;
  &:hover {
    color: #ec8235;
  }
`

export const Preview = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 20px;
  row-gap: 30px;
  @media (max-width: 1020px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: 1fr;
    row-gap: 20px;
  }
`
